// KAN-728 — tiny, import-free bus so CompanySettingsContext can say "the plan
// changed" without importing the plan store (and its supabase client).
const handlers = new Set();

/** The plan store registers here while a reader is mounted; returns an unsubscribe. */
export function onCompanyPlanStale(fn) {
  handlers.add(fn);
  return () => handlers.delete(fn);
}

/** Plan / allowance / feature switches changed server-side: re-read for whoever is looking. */
export function notifyCompanyPlanStale() {
  handlers.forEach((fn) => fn());
}
